import angular from 'angular';
import {localeEvents} from '@/angular/modules/vrm.locales';
import moment from 'moment';
import _ from 'lodash';
angular.module('vrm.core').controller('ProfileAppearanceController', ProfileAppearanceController);

/**
 * @constructor
 * @ngInject
 */
function ProfileAppearanceController($log, $scope, vrmNotificationsService, vrmNotificationType, locale, AppearanceService, UserService) {

    $log.info('ProfileAppearanceController');
    $scope.screensaverTimeouts = [
        {id: 0, name: 'profilesettings.screensaver_disabled'},
        {id: 60000, name: 'profilesettings.screensaver_one_minute'},
        {id: 180000, name: 'profilesettings.screensaver_x_minutes', minutes: 3},
        {id: 300000, name: 'profilesettings.screensaver_x_minutes', minutes: 5},
        {id: 600000, name: 'profilesettings.screensaver_x_minutes', minutes: 10},
        {id: 900000, name: 'profilesettings.screensaver_x_minutes', minutes: 15},
        {id: 1800000, name: 'profilesettings.screensaver_x_minutes', minutes: 30}
    ];
    $scope.temperatureOptions = [
        {id: false, name: 'profilesettings.celsius'},
        {id: true, name: 'profilesettings.fahrenheit'},
    ];
    $scope.volumeOptions = [
        {id: false, name: 'profilesettings.liters'},
        {id: true, name: 'profilesettings.gallons'},
    ]
    $scope.weekOptions = [
        {id: 'auto', name: 'datepicker.auto'},
        {id: 'sunday', name: 'datepicker.sunday' },
        {id: 'monday', name: 'datepicker.monday'},
    ]
    $scope.darkModel = AppearanceService.model;
    $scope.selected = {screensaverTimeout:  null, useFahrenheit: null, useGallons: null, weekStartPreference:null};
    $scope.customThemesEnabled = AppearanceService.isCustomThemesEnabled();

    function setScreenSaver() {
        if ($scope.user && $scope.selected.screensaverTimeout === null) {
            const currentTimeout = $scope.user.screensaverTimeout ? parseInt($scope.user.screensaverTimeout) : 0;
            $scope.selected.screensaverTimeout = _.find($scope.screensaverTimeouts, val => val.id === currentTimeout);
        }
    }

    locale.ready('profilesettings').then(() => {
        // Populate select
        $scope.$watch('user', (user) => {
            setScreenSaver();
            if (user) {
                $scope.selected.useFahrenheit = _.find($scope.temperatureOptions, (val) => {
                    return val.id === user.useFahrenheit;
                });
                $scope.selected.useGallons = _.find($scope.volumeOptions, (val) => {
                    return val.id === user.useGallons;
                });
                $scope.selected.weekStartPreference = _.find($scope.weekOptions, (val) => {
                    return val.id === user.weekday;
                });
            }
        });
    });

    $scope.$on(localeEvents.localeChanges, () => {
        locale.ready('profilesettings').then(() => {
            $scope.selected.screensaverTimeout = null;
            setScreenSaver();
        });
    });

    $scope.saveDarkMode = () => {
        if ($scope.darkModel.darkmode === 0) {
            // No preference
            localStorage.removeItem(AppearanceService.DARK_MODE_KEY);
            AppearanceService.toggleDarkMode(window.matchMedia('(prefers-color-scheme: dark)').matches);
        } else {
            localStorage.setItem(AppearanceService.DARK_MODE_KEY, $scope.darkModel.darkmode);
            AppearanceService.toggleDarkMode($scope.darkModel.darkmode === 1);
        }
        $scope.darkModel.darkmodeStored = $scope.darkModel.darkmode;
        vrmNotificationsService.add({
            type: vrmNotificationType.SUCCESS,
            message: locale.getString('dark-mode.setting_changed')
        });
    }
    $scope.saveUnitsForm = () => {
        let data={}
        data.useFahrenheit =  _.get($scope.selected.useFahrenheit ,'id',null);
        data.useGallons = _.get($scope.selected.useGallons ,'id',null);
        UserService.save(data);

    }
    $scope.saveWeekForm = () => {
        let weekStart=0;
        switch($scope.selected.weekStartPreference.id){
            case("sunday"):
                weekStart=0;
                break;
            case("monday"):
                weekStart=1;
                break;
            case("auto"):
                weekStart=$scope.weekStartLocale(navigator.language);
                break;
            default:
                weekStart=$scope.weekStartLocale(navigator.language);
                break;
        }
        moment.updateLocale(moment.locale(),{week:{dow:weekStart}});
        UserService.save({weekday:$scope.selected.weekStartPreference.id});
     }

     $scope.saveCustomThemesForm = () => {
        const changed = $scope.customThemesEnabled !== AppearanceService.isCustomThemesEnabled();
        AppearanceService.setCustomThemesEnabled($scope.customThemesEnabled);
        if (changed) window.location.reload();
     }

     $scope.saveScreenSaverForm=()=>{
        let data={}
        data.screensaverTimeout = _.get($scope.selected.screensaverTimeout ,'id',null);
        UserService.save(data);
     }

     $scope.weekStart=(region, language)=> {
        const regionSat = 'AEAFBHDJDZEGIQIRJOKWLYOMQASDSY'.match(/../g);
        const regionSun = 'AGARASAUBDBRBSBTBWBZCACNCODMDOETGTGUHKHNIDILINJMJPKEKHKRLAMHMMMOMTMXMZNINPPAPEPHPKPRPTPYSASGSVTHTTTWUMUSVEVIWSYEZAZW'.match(/../g);
        const languageSat = ['ar','arq','arz','fa'];
        const languageSun = 'amasbndzengnguhehiidjajvkmknkolomhmlmrmtmyneomorpapssdsmsnsutatethtnurzhzu'.match(/../g);

        return (
          region ? (
            regionSun.includes(region)||  regionSat.includes(region)? 0 : 1) : (
            languageSun.includes(language)||languageSat.includes(language) ? 0 : 1));
      }

      $scope.weekStartLocale=(locale)=> {
        const parts = locale.match(/^([a-z]{2,3})(?:-([a-z]{3})(?=$|-))?(?:-([a-z]{4})(?=$|-))?(?:-([a-z]{2}|\d{3})(?=$|-))?/i);
        return $scope.weekStart(parts[4], parts[1]);
      }


}
